import { TenantEntity } from '../TenantEntity'

export class VgmInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'VgmInfo'
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get seaHouseId() {
    return this._data.seaHouseId
  }
  set seaHouseId(seaHouseId) {
    this._data.seaHouseId = seaHouseId
  }
  get seaHouseState() {
    return this._data.seaHouseState
  }
  set seaHouseState(seaHouseState) {
    this._data.seaHouseState = seaHouseState
  }
  get thirdPartyCarrier() {
    return this._data.thirdPartyCarrier
  }
  set thirdPartyCarrier(thirdPartyCarrier) {
    this._data.thirdPartyCarrier = thirdPartyCarrier
  }
  get mbl() {
    return this._data.mbl
  }
  set mbl(mbl) {
    this._data.mbl = mbl
  }
  get portOfLoading() {
    return this._data.portOfLoading
  }
  set portOfLoading(portOfLoading) {
    this._data.portOfLoading = portOfLoading
  }
  get vessel() {
    return this._data.vessel
  }
  set vessel(vessel) {
    this._data.vessel = vessel
  }
  get voyage() {
    return this._data.voyage
  }
  set voyage(voyage) {
    this._data.voyage = voyage
  }
  get wharf() {
    return this._data.wharf
  }
  set wharf(wharf) {
    this._data.wharf = wharf
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get boxHolder() {
    return this._data.boxHolder
  }
  set boxHolder(boxHolder) {
    this._data.boxHolder = boxHolder
  }
  get vgmCutOffDate() {
    return this._data.vgmCutOffDate
  }
  set vgmCutOffDate(vgmCutOffDate) {
    this._data.vgmCutOffDate = vgmCutOffDate
  }
  get yard() {
    return this._data.yard
  }
  set yard(yard) {
    this._data.yard = yard
  }
  get sendChannel() {
    return this._data.sendChannel
  }
  set sendChannel(sendChannel) {
    this._data.sendChannel = sendChannel
  }
}
